import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, Scale, Moon, Sun, Search, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import '../styles/custom.css';
import logo from '../images/logojudiciary.png';

export function CompactHeader({ darkMode, toggleDarkMode }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState({
    left: 0,
    top: 0,
    width: 0,
  });
  const navContainerRef = useRef(null);
  const navigate = useNavigate();

  const navigationItems = [
    {
      title: 'About Us',
      path: '/about',
      hasDropdown: true,
      sections: [
        {
          title: 'Leadership',
          items: [
            { name: 'Court Leadership', path: '/about#CourtLeadership' },
            { name: 'Judges & Magistrates', path: '/JudgesMagistrates' },
            { name: 'Principal Officers', path: '/PrincipalOfficers' },
            { name: 'Heads of Unit', path: '/HeadsofUnit' },
            { name: 'Retired Chief Judges', path: '/RetiredChiefJudges' },
            {
              name: 'Retired Elevated Deceased Judges',
              path: '/RetiredElevatedDeceasedJudges',
            },
          ],
        },
        {
          title: 'Our Mission',
          items: [
            { name: 'Vision & Mission', path: '/about#vision-mission' },
            { name: 'Core Values', path: '/about#core-values' },
            { name: 'Strategic Plan', path: '/about#strategic-plan' },
            { name: 'Annual Reports', path: '/about#annual-reports' },
            { name: 'Gallery', path: '/gallery' },
            { name: 'News', path: '/newslanding' },
          ],
        },
      ],
    },
    // {
    //   title: 'Court Divisions',
    //   path: '/court-divisions',
    //   hasDropdown: true,
    //   sections: [
    //     {
    //       title: 'High Court',
    //       items: [
    //         { name: 'Civil Division', path: '/court-divisions#civil' },
    //         { name: 'Criminal Division', path: '/court-divisions#criminal' },
    //         { name: 'Commercial Division', path: '/court-divisions#commercial' },
    //         { name: 'Family Division', path: '/court-divisions#family' }
    //       ]
    //     },
    //     {
    //       title: 'Magistrate Courts',
    //       items: [
    //         { name: 'Chief Magistrate', path: '/court-divisions#chief-magistrate' },
    //         { name: 'Senior Magistrate', path: '/court-divisions#senior-magistrate' },
    //         { name: 'Family Court', path: '/court-divisions#family-court' },
    //         { name: 'Traffic Court', path: '/court-divisions#traffic-court' }
    //       ]
    //     },
    //     {
    //       title: 'Special Courts',
    //       items: [
    //         { name: 'Customary Courts', path: '/court-divisions#customary' },
    //         { name: 'Multi-Door Courthouse', path: '/court-divisions#multi-door' },
    //         { name: 'Small Claims Court', path: '/court-divisions#small-claims' }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   title: 'E-Filing Services',
    //   path: '/e-filing',
    //   hasDropdown: true,
    //   sections: [
    //     {
    //       title: 'Online Services',
    //       items: [
    //         { name: 'File a Case', path: '/e-filing#file-case' },
    //         { name: 'Case Status', path: '/e-filing#case-status' },
    //         { name: 'Document Upload', path: '/e-filing#document-upload' },
    //         { name: 'Payment Portal', path: '/e-filing#payment' }
    //       ]
    //     },
    //     {
    //       title: 'Digital Tools',
    //       items: [
    //         { name: 'Virtual Hearings', path: '/e-filing#virtual-hearings' },
    //         { name: 'Online Mediation', path: '/e-filing#mediation' },
    //         { name: 'E-Signatures', path: '/e-filing#e-signatures' },
    //         { name: 'Case Tracking', path: '/e-filing#tracking' }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   title: 'Legal Resources',
    //   path: '/legal-resources',
    //   hasDropdown: true,
    //   sections: [
    //     {
    //       title: 'Forms & Documents',
    //       items: [
    //         { name: 'Court Forms', path: '/legal-resources#court-forms' },
    //         { name: 'Legal Templates', path: '/legal-resources#templates' },
    //         { name: 'Fee Schedule', path: '/legal-resources#fees' },
    //         { name: 'Filing Guidelines', path: '/legal-resources#guidelines' }
    //       ]
    //     },
    //     {
    //       title: 'Information',
    //       items: [
    //         { name: 'Court Rules', path: '/legal-resources#court-rules' },
    //         { name: 'Practice Directions', path: '/legal-resources#practice-directions' },
    //         { name: 'Legal Aid', path: '/legal-resources#legal-aid' },
    //         { name: 'Self-Help Guides', path: '/legal-resources#self-help' }
    //       ]
    //     }
    //   ]
    // },
    {
      title: 'Probate Pub.',
      path: '/ProbatePub',
      hasDropdown: false,
    },
    {
      title: 'Cause Lists',
      path: '/CauseLists',
      hasDropdown: false,
    },
    {
      title: 'Affidavit Verification',
      path: '/affidavit-verification',
      hasDropdown: true,
      sections: [
        {
          title: 'High Court',
          items: [
            { name: 'Verification Platform', path: '/VerificationHighCourt' },
          ],
        },
        {
          title: 'Magistrate Court',
          items: [
            {
              name: 'Verification Platform',
              path: 'https://lagoscomis.lagosjudiciary.gov.ng/verification',
            },
          ],
        },
      ],
    },

    {
      title: 'Contact',
      path: '/contact',
      hasDropdown: false,
    },
  ];

  const calculateDropdownPosition = (element) => {
    const rect = element.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    const maxDropdownWidth = 800;
    const padding = 20;
    const dropdownWidth = Math.min(
      maxDropdownWidth,
      viewportWidth - padding * 2
    );
    const topPosition = rect.bottom + window.scrollY;

    const navContainer = navContainerRef.current;
    let leftPosition;

    if (navContainer) {
      const navRect = navContainer.getBoundingClientRect();
      const navCenter = navRect.left + navRect.width / 2;
      const idealLeft = navCenter - dropdownWidth / 2;

      if (idealLeft < padding) {
        leftPosition = padding;
      } else if (idealLeft + dropdownWidth > viewportWidth - padding) {
        leftPosition = viewportWidth - dropdownWidth - padding;
      } else {
        leftPosition = idealLeft;
      }
    } else {
      leftPosition = (viewportWidth - dropdownWidth) / 2;
    }

    return {
      left: Math.max(padding, leftPosition),
      top: topPosition,
      width: dropdownWidth,
    };
  };

  const handleMouseEnter = (item, element) => {
    if (item.hasDropdown) {
      const position = calculateDropdownPosition(element);
      setDropdownPosition(position);
      setActiveDropdown(item.title);
    }
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  const DropdownPortal = ({ item }) => {
    if (!activeDropdown || activeDropdown !== item.title) return null;

    return createPortal(
      <div
        className='bg-white dark:bg-gray-800 shadow-2xl border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden z-[99999]'
        style={{
          position: 'fixed',
          left: `${dropdownPosition.left}px`,
          top: `${dropdownPosition.top}px`,
          width: `${dropdownPosition.width}px`,
          maxHeight: '70vh',
          overflowY: 'auto',
        }}
        onMouseEnter={() => setActiveDropdown(item.title)}
        onMouseLeave={handleMouseLeave}
      >
        <div className='p-6'>
          <div
            className={`grid gap-8 ${
              item.sections?.length === 3 ? 'grid-cols-3' : 'grid-cols-2'
            }`}
          >
            {item.sections?.map((section, sectionIndex) => (
              <div key={sectionIndex} className='space-y-4'>
                <h3 className='font-semibold text-blue-900 dark:text-blue-300 text-sm uppercase tracking-wide border-b border-gray-200 dark:border-gray-600 pb-2'>
                  {section.title}
                </h3>
                <div className='space-y-2'>
                  {section.items.map((subItem, subIndex) => (
                    <Link
                      key={subIndex}
                      to={subItem.path}
                      className='block text-sm text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-700 px-3 py-2 rounded-md transition-colors'
                      onClick={() => setActiveDropdown(null)}
                    >
                      {subItem.name}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>,
      document.body
    );
  };

  return (
    <header className='relative bg-white dark:bg-gray-900 shadow-sm border-b border-gray-200 dark:border-gray-700 z-1'>
      {/* Single Row Header - Exact 110px height for proper logo spacing */}
      <div className='container mx-auto px-4 sm:px-6 max-w-7xl'>
        <div className='flex items-center justify-between h-[110px]'>
          {/* Logo Section - 100px x 100px */}
          <Link
            to='/'
            className='flex items-center space-x-4 flex-shrink-0 hover:opacity-90 transition-opacity'
          >
            <div className='flex items-center justify-center'>
              <img src={logo} alt='logo' className='logo-width' />
            </div>
            <div className='hidden sm:block'>
              <h1 className='text-xl lg:text-1xl font-bold text-gray-900 dark:text-white leading-tight'>
                LAGOS STATE JUDICIARY
              </h1>
              <p className='text-xs text-gray-600 dark:text-gray-400 mt-1'>
                Justice, and, Progress
              </p>
            </div>
          </Link>

          {/* Desktop Navigation - Center */}
          <div className='hidden lg:flex flex-1 justify-center max-w-3xl'>
            <div
              ref={navContainerRef}
              className='bg-gray-50 dark:bg-gray-800 rounded-full px-3 py-2 shadow-inner'
            >
              <nav className='flex items-center space-x-1'>
                {navigationItems.map((item, index) => (
                  <div
                    key={index}
                    className='relative'
                    onMouseEnter={(e) =>
                      handleMouseEnter(item, e.currentTarget)
                    }
                    onMouseLeave={handleMouseLeave}
                  >
                    <Link
                      to={item.path}
                      className='flex items-center px-4 py-2.5 text-gray-700 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-700 hover:text-blue-600 dark:hover:text-blue-400 rounded-full text-sm font-medium transition-colors whitespace-nowrap'
                    >
                      {item.title}
                      {item.hasDropdown && (
                        <ChevronDown className='ml-1.5 h-3 w-3' />
                      )}
                    </Link>

                    {item.hasDropdown && <DropdownPortal item={item} />}
                  </div>
                ))}
              </nav>
            </div>
          </div>

          {/* Right Section - Utilities Only */}
          <div className='flex items-center space-x-3 flex-shrink-0'>
            {/* Case Lookup Button - Hidden on mobile */}
            <div className='hidden lg:block'>
              <Button
                variant='outline'
                size='sm'
                className='bg-orange-500 hover:bg-orange-600 text-white'
                onClick={() => navigate('/login')}
              >
                Login/Create e-Filing Account
              </Button>
            </div>

            {/* Utility Icons */}
            <div className='flex items-center space-x-1'>
              {/* <button className="p-2.5 text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800">
                <Search className="h-4 w-4" />
              </button> */}
              <button
                onClick={toggleDarkMode}
                className='p-2.5 text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800'
                aria-label='Toggle theme'
              >
                {darkMode ? (
                  <Sun className='h-4 w-4' />
                ) : (
                  <Moon className='h-4 w-4' />
                )}
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className='lg:hidden p-2.5 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg'
            >
              {isMobileMenuOpen ? (
                <X className='h-5 w-5' />
              ) : (
                <Menu className='h-5 w-5' />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className='lg:hidden bg-gray-50 dark:bg-gray-800 rounded-lg mb-4 p-4 absolute top-full left-4 right-4 shadow-xl border border-gray-200 dark:border-gray-700 z-50'>
            <div className='space-y-4'>
              {/* Mobile Navigation */}
              <div className='space-y-2'>
                {navigationItems.map((item, index) => (
                  <Link
                    key={index}
                    to={item.path}
                    className='block px-4 py-3 text-gray-700 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-700 rounded-md text-sm font-medium'
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.title}
                  </Link>
                ))}
              </div>

              {/* Mobile Case Lookup Button */}
              <div className='border-t border-gray-200 dark:border-gray-600 pt-4'>
                <Button
                  className='bg-orange-500 hover:bg-orange-600 text-white'
                  onClick={() => {
                    navigate('/login');
                    setIsMobileMenuOpen(false);
                  }}
                >
                  Login/Create e-Filing Account
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
